import React, { useState, Component } from 'react';
import Singleton from '../core/singleton';
import AxiosServices from '../services/AxiosServices';


export default props => {
    const infinite = JSON.parse(null);
    const { product } = props;
    const { stock } = product;
    const { getTradByKey } = Singleton.getInstance();
    const [stockQuantity, setStockQuantity] = useState((stock && stock.quantity !== null) ? stock.quantity : null);
    const hasInfiniteStock = (stock && stock.quantity === null) ? true : false
    const [unlimitedStock, setUnlimitedStock] = useState(hasInfiniteStock);

    /** increment or decrement the stock*/
    const onClickEvent = operande => {
        let r = (operande === '+') ? stockQuantity + 1 :
            (stockQuantity > 0)
                ? stockQuantity - 1
                : 0;
        setStockQuantity(r);
    }

    /** finally submit the modification */
    const updateStockQuantity = () => {
        let quantity = (!unlimitedStock) ? Number(document.querySelector('.StockSelectorInput').value) : infinite;
        AxiosServices.putStock(props.product.retail_product_uuid, quantity).then(() => {
            props.onStockUpdate();
            props.onClose();
        });
    }

    const SubmitButton = () => ((stock && (stock.quantity !== stockQuantity) || (hasInfiniteStock !== unlimitedStock)))
        ? <div className="modal-footer">
            <button
                onClick={() => updateStockQuantity()}
                className="btn btn-success btn-block validateStockModification">{getTradByKey('validate')}</button>
        </div>
        : null;

    return <div className='StockSelector'>
        <div className="modal-header">
            <h5 className="modal-title">{props.product.title}</h5>
            <button onClick={() => props.onClose()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div className="modal-body">
            <form onSubmit={e => e.preventDefault()}>
                <fieldset disabled={unlimitedStock}>
                    <div className='text-center mb-3'>
                        <div className="mb-3">
                            <button
                                onClick={e => onClickEvent('+')}
                                className='btn btn-primary btn-lg w-100'>+</button>
                        </div>
                        <div className="mb-3">
                            <input
                                onChange={e => {
                                    let el = String(e.target.value);
                                    let regExp = /^0[0-9].*$/;
                                    let isStartingWith0 = regExp.test(el);
                                    let x = (isStartingWith0) ? parseInt(el, 10) : Number(el);
                                    setStockQuantity(x);
                                }}
                                defaultValue="0"
                                min="0"
                                className="w-100 form-control height-140px StockSelectorInput"
                                type="number"
                                value={String(parseInt(stockQuantity))} />
                        </div>
                        <div>
                            <button
                                onClick={e => onClickEvent('-')}
                                className='btn btn-primary btn-lg w-100'>-</button>
                        </div>
                    </div>
                </fieldset>
            </form>
            <label className="align-items-center d-flex justify-content-between mb-0" onClick={() => setUnlimitedStock(!unlimitedStock)}>{getTradByKey("do_not_manage_the_stock")} <i className={`fas fa-2x fa-toggle-${(unlimitedStock) ? 'on' : 'off'}`}></i>
            </label>
        </div>
        <SubmitButton />
    </div>

}